import { render, staticRenderFns } from "./LomEventsMonthList.vue?vue&type=template&id=ec920e34&scoped=true"
import script from "./LomEventsMonthList.vue?vue&type=script&lang=js"
export * from "./LomEventsMonthList.vue?vue&type=script&lang=js"
import style0 from "./LomEventsMonthList.vue?vue&type=style&index=0&id=ec920e34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec920e34",
  null
  
)

export default component.exports